import React from 'react'
import url from 'libraries/front-end-core/core/url'
import { LEGISLATION_MENU } from 'constants/controllers'
import Breadcrumbs from 'components/Breadcrumbs'

export default ({ aol }) => (
  <div className='bg-page-background w-100'>
    <div className='layout-width-constraint pv6'>
      <Breadcrumbs
        icon='legislation'
        crumbs={[{
          label: 'Legislation',
          href: url(LEGISLATION_MENU)
        }]}
        current='All Legislation'
      />
    </div>
  </div>
)
